import React from "react";

export const CustomLoader = () => {
    return <div className={"custom-loader"} />;
};